// @flow
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ResultAndRanking from 'components/team/teamDetail/ResultAndRanking';

import type {  StateType } from 'types/Actions';
import type { StateProps } from 'components/team/teamDetail/ResultAndRanking';

const mapStateToProps = (state: StateType): StateProps => ({
  ranking: state.rankingState.ranking,
  competitions: state.teamResultState.competitions,
  resultStatus: state.teamResultState.status,
  nextMatches: state.teamCalendarState.nextMatches,
  calendarStatus: state.teamCalendarState.status,
  clubNom: state.settingsState.title,
});

export default withRouter(connect(mapStateToProps)(ResultAndRanking));
